
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/legal/guild",
      function () {
        return require("private-next-pages/[locale]/legal/guild/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/legal/guild"])
      });
    }
  